import React from 'react';

const DeliveryMethods: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Delivery Methods</h1>
          <p className="text-gray-600 mt-2">
              Delivery to Customer with
          </p>
        </div>



        {/* Main Users Image */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <div className="mb-6">
            <img
              src="/images/settings/deliverymethods/deliverymethods.png"
              alt="Users Settings Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>

        {/* Add Custom Role Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Add Custom DeliveryMethod</h2>
          <p className="text-gray-600 mb-4">
            DeliveryMethods means to deliver item with persons or somethings.
          </p>
          <p className="text-gray-600 mb-4">
            To add a custom deliverymethods:
          </p>
          <ol className="list-decimal list-inside text-gray-600 space-y-2 mb-4">
            <li>Go to Settings</li>
            <li>Select Delivery Methods</li>
            <li>Click the New Delivery Method button in the top right corner of the page.</li>
            <li>Fill the Delivery Methods.</li>
            <li>Click Save.</li>
          </ol>
          <div className="mb-6">
            <img
              src="/images/settings/deliverymethods/deliverymethods-new.png"
              alt="Add Custom DeliveryMethods Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>

        {/* Edit Role Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Edit Delivery Methods</h2>
          <p className="text-gray-600 mb-4">
          After you have added a new Delivery Method, you can edit their data if required. Here’s how:
          </p>
          <ol className="list-disc list-inside text-gray-600 space-y-2 mb-4">
            <li>Go to Settings </li>
            <li>Select the DeliveryMethod you want to edit and click down arrow button</li>
            <li>Click Edit.</li>
            <li>Make the required changes and click Save.</li>
          </ol>
          <div className="mb-6">
            <img
              src="/images/settings/deliverymethods/deliverymethods-edit.png"
              alt="Add Custom Role Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
          <div className="mb-6  mt-6">
            <img
              src="/images/settings/deliverymethods/deliverymethods-edit-save.png"
              alt="role Settings Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>



      </div>

    </div>
  );
};

export default DeliveryMethods;
